import { render } from "./withdraw-modify.vue?vue&type=template&id=1edbc81c&scoped=true"
import script from "./withdraw-modify.vue?vue&type=script&lang=js"
export * from "./withdraw-modify.vue?vue&type=script&lang=js"

import "./withdraw-modify.vue?vue&type=style&index=0&id=1edbc81c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edbc81c"]])

export default __exports__